import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-girl-guides-scouts',
  templateUrl: './girl-guides-scouts.component.html',
  styleUrls: ['./girl-guides-scouts.component.scss']
})
export class GirlGuidesScoutsComponent implements OnInit {

  scoutImages = [
    '/assets/img/quick-links/girls-scouts/1.jpg',
    '/assets/img/quick-links/girls-scouts/2.jpg',
  ];

  constructor() { }

  ngOnInit(): void { }

}
